import React, { useEffect, useCallback } from 'react'
import { Panel, TabPanel, Container, TyanDatetimeField } from '@sencha/ext-modern'

import Block from './Block'
import { useInstData } from 'tyan/public/hooks'
import Controls from './Controls'
import { FormDataContext, IsDialogContext } from 'Tyan/public/components/context'
const edges = {
	left: 'east',
	right: 'west',
	top: 'south',
	bottom: 'north',
}

const renderOneFieldset = ({ title: name, _fieldset: fieldset, data, minWidth, defaultProps, fieldsetID }) => {
	return fieldset && fieldset.length ? <Block {...{ name, data, minWidth, fieldset, fieldsetID }} {...defaultProps} /> : null
}

const renderSubFieldsets = ({ _fieldsets: fieldsets, data, minWidth, defaultProps: { default: _default = {}, ...rest }, fieldsetID }) => {
	const hasGrid = JSON.stringify(fieldsets).includes('grid":')
	return <TabPanel id={`subfieldsets-${fieldsetID}`} flex={1} height="100%" tabBar={{ defaultTabUI: 'lightgrey', shadow: false, style: { backgroundColor: '#f5f5f5' }, layout: { pack: 'left' } }}
		{...(hasGrid ? { layout: { animation: '' } } : {})}>
		{
			fieldsets.map(({ _fieldset, cdt, title, badgeText, default: _myDefault = {}, ...myRest }, key) => {
				return (!cdt || cdt()) && <Container id={`subfieldset-${key}-${fieldsetID}`} key={`${title}_${key}`} scrollable layout="fit" allowHeader={undefined}
					tab={{ flex: 0, minWidth: 100, title, badgeText, ui: "title", margin: '0', style: { fontSize: '16px', /* lineHeight: '14px',  */fontFamily: '微软雅黑' } }} >
					{renderOneFieldset({ title, _fieldset, data, minWidth, defaultProps: { default: { ..._default, ..._myDefault }, ...rest, ...myRest }, fieldsetID: `subfieldset-${key}-${fieldsetID}` })}
				</Container> || null
			}).filter(o => o)
		}
	</TabPanel>
}

const renderFieldset = ({ _fieldset, title, _fieldsets, data, minWidth = Ext.os.is.Phone ? 200 : 500, ...defaultProps }, fieldsetID) => {
	// minWidth: 控制fieldset的最小宽度
	if (_fieldset) return renderOneFieldset({ title, _fieldset, data, minWidth, defaultProps, fieldsetID })
	if (_fieldsets) return renderSubFieldsets({ _fieldsets, data, minWidth, defaultProps, fieldsetID })
	return null
}

const Form = props => {
	const { me, me: { formID } } = useInstData(props, useCallback(() => {
		// Tyan.checkForm.init(props.data)
		return {
			formID: `form-${Tyan.getUuid()}`,
			hasChangedValues: () => Tyan.pubForm.hasChangedValues(me.props.data)   // 检查有没有changedValues
		}
	}, []))

	const { isTooltip } = props

	// console.log('formID:', formID)
	useEffect(() => {
		Tyan.locationControl.forms.push(me)
		document.activeElement.blur()
		return () => {
			const { forms } = Tyan.locationControl
			forms.includes(me) && forms.splice(forms.indexOf(me), 1)
		}
	}, [])

	const { fieldsets, controls, data, maxWidth, minWidth, isManagerInner, isDialog, fullForm, shadow = true, ...formRest } = props
	return <FormDataContext.Provider value={data}>
		<IsDialogContext.Provider value={isDialog}>
			{!isTooltip && <Controls {...{ controls }} /> || null}
			<Container id={`container-${formID}`} layout={'vbox'/* fieldsets.length == 1 ? 'vbox' : 'fit' */} maxWidth={maxWidth} minWidth={minWidth} hidden={props.hidden}>
				<Panel id={`panel-container-${formID}`}
					{...(fieldsets.length === 1 ? { maxHeight: "calc(100% - 15px)" } : { flex: 1 })} {...(fullForm ? { flex: 1 } : {})}
					shadow={!isDialog && !isManagerInner && !isTooltip && !Tyan.isPhone && shadow} layout="fit" margin={isManagerInner || Tyan.isPhone ? '0' : "5 10 10 10"}
				>
					{fieldsets.map(({ title, key, cdt, docked, width, height, titleAlign, resizable, ...rest }, fieldsetIndex) => {
						const props = { title: title || null, docked, width, height, titleAlign, resizable }
						if (cdt && !cdt() || (!rest._fieldset && !rest._fieldsets)) return null

						const { name } = rest
						// collapsible={docked} Ext.React有bug，效果不好
						props.docked && props.resizable === undefined && (props.resizable = { split: true, edges: edges[docked], dynamic: true })
						for (let key in props)
							props[key] === undefined && delete props[key]

						// width/height: 控制布局的默认宽度/高度，可以使用百分百或数字，如：30%、300px
						key = key || `${title}_${name}_${fieldsetIndex}`
						return <Panel id={`fieldset-panel-${Tyan.shortMd5(key)}-${formID}`} layout='fit' key={key} /* title={title || null}  */
							scrollable ui="light" {...props}
						>
							{renderFieldset({ ...formRest, ...rest, title, data }, `fieldset-${fieldsetIndex}-${formID}`)}
						</Panel>
					}).filter(o => o)}
				</Panel>
			</Container >
			{false && <TyanDatetimeField />}
		</IsDialogContext.Provider>
	</FormDataContext.Provider>
}

export default Form